// extracted by mini-css-extract-plugin
export default {"container":"AddIncidentForm_container__ub+5T","header":"AddIncidentForm_header__QIi4e","footer":"AddIncidentForm_footer__Ll9nx"};